var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('gmap-map',{ref:"map",staticClass:"map",attrs:{"zoom":9,"center":{ lat: -33.867001, lng:151.209113 }}})}
var staticRenderFns = []

export { render, staticRenderFns }